import { useEffect, useState } from 'react';
import protocolApi from '../api/protocol-api';
import { PROTOCOL_CATEGORY_OPTIONS } from '../utils/protocol-form.util';

// Category labels come from the backend — the same list the app shows — so
// the dashboard can't drift from it. Falls back to the static codes/labels.
export const useProtocolCategories = () => {
  const [options, setOptions] = useState(PROTOCOL_CATEGORY_OPTIONS);

  useEffect(() => {
    let cancelled = false;
    protocolApi.getCategories().then(({ data, success }) => {
      if (!cancelled && success && Array.isArray(data)) {
        setOptions(data.map(({ code, name }) => ({ value: code, label: name })));
      }
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return options;
};
